import React from 'react';

export const trianglePath = 'M32 0l32 51H0z';
export default class Triangle extends React.PureComponent{
  render() {
    return <path d={trianglePath} className="fill-current" />;
  }
}
